import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button } from 'primereact/button';
const PaymentForm = () => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        var port;
        if (window.location.port === "" || window.location.port === 'nothing') {
            port = "";
        }
        else {
            port = ":" + window.location.port;
        }
        const result = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: window.location.protocol + "//" + window.location.hostname + port + "/public/stripe/payment-success",
            },
        });

        if (result.error) {
            // Show error to your customer (for example, payment details incomplete)
            console.log(result.error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />
            <div>
                <Button className="depositButton" disabled={!stripe} size="small">Je valide le paiement</Button> 
                <div className="PoweredByStripe"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAAAyCAMAAAA0s4RdAAAAQlBMVEVHcExmW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9mW/9XVEs2AAAAFXRSTlMAYyE5rtVF+AMS43TvlS0JUrvKooP6fpKsAAAE5UlEQVRo3u2Z6XasKBCAlX0t9vd/1SlQO5rYiTdn5qY9k/rRAQXls1bINP3Kr/zKJ6L0XSQ8IwDLMr+JJC/0CYOuRvLEbiLZySQ+MECSLJKgbiIaqnGzOjKQJG24lftONLv5eMlLe7swBNzAvk8dC/cLplH6fbdK8TJLC4SSiyMTJ/te1i+CoGvi72z9udj9tyecqZ9KrwDqaNittasQQu5GEuN/yKpLduX7ENTZn4dQBVd8NALKc7HkFhAqBPWAOET/QPbeGdRhkvpbEOrd37MAb0tKrEY9IHitVhNba4RaosZGhSniRRAeR22pgMw4yQt1EYJQFPI9Tw/VL28VxT55gppNGyLjVJaWIbHT8Nbq6hMMf7Mb95biQuQx0lV9CUJ556QznnwrQvIWl+jXnqXP2bUVYt4gHIlyae0hVnH9gcJs3aouQZSWfTHtWzlc8zV02/Ykaoc0VuZkX+uAkF0TpxBuXMWMpvsklzuJoxchKgY/10drKijqjwD+aEDdBICAP+MqtjWl6Is4aAATIWAHAQJrftUnrL/ru7ozAwibFnPKMcYwIIy3YgfhKo150Vi/7WYN/bK/DjHsgibXZBaTdV6hGSSNak1aFydlAkyRJskUCEPrYwgYuZTcPSCMwVE0sJ5/qXkUCDAgek/rt+jUVzky1w4iqbVbxrjSrQq7XF+FUF0TJKNhpWYAHCeKdU3W5kNpyTK0NvymLlmNTZvwRbi67HN7QMjkect6OEdtj5Smh4fysTN7yxPjU9OPEGp4OOlz2DzPFe86uAbBC3OtBLuaow9JRmJks9gQ4AwowiXFKxg5hMxEUePA4svwSQ8I1Bs1Dec50FnGN8dezL/vzL6GQHwkprztHJ1eg5DOcYxOZdgfLkfZVqMsJlGXdUQPyxj+xvL67d6VUmxWuHNs/I518s0i6JsNhJlvYecIIc8g7IAwO4hd0fcphAfAPKEeEAFcZk4w43FRER2wC2wQo1vhGQQSsHbYchGbRpjN+mtN+D4OOrbJiyS47NjLQvJiTlNg6OBo3s6JCc2J9vJzWiCE5DC69dyc+gPkbgumepgKI3c5+qUmhgexEWHLdlyj/giiO3ZFx8aHzz20gcOPh8kQK4W5eLVAIF+2ttjpiWMPi9hVqtrPJCxm4sQoOwC5zjSRQenaHagOzzCxPyTsd0yfZuztFk0SNRDHfhYTJ4bL2j+6x8CLLbLscUnpXTtCbOPGiDUvG4Nz6QiqO7dWaHAm9WSKywI/rIoxcqaJxlmWiyePq47V6rOLF2unB6ymcTmkWrIVoWsnxpHzlgwWcNBoYbIjAHqdScg69+DW3Ws2KWpN1EvZ8V4Tj2FhUvWtG//jKva00EDzs9NBE6tkmDTbILaw8xEikaF9+bcgzgtv4/YnK2FmBjO+47Xrm3jM61gKCM75Ynv9JDUOCF7w3laIhjlhT5ps9U9A0PdFeSBUCKq3E+DRDgSlm6QajZGoMbKjfT7m9p5AY1U/AaHUiZl9sVtRjzzx+nvsfxmivCDE18dIYn/4qnl6rVNM5ZOf4cI5ZtwnaUNeSxX60kf1h7g33/BQHAOZORiQzgZuBxH83pq6dbl8N4pgZQnvD5h5vNO/KBQUmT448sxlslHcRGYsSc5OxqByrGnuIoadG47Cwnu+iQh4+u94paZf+ZX/t/wDgxmCx8q7PwMAAAAASUVORK5CYII=" ></div>
            </div>

        </form>

    )
};

export default PaymentForm;